import { render } from "./confirmarPedido.vue?vue&type=template&id=d7626538"
import script from "./confirmarPedido.vue?vue&type=script&lang=js"
export * from "./confirmarPedido.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__